// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"354":"24ea3328","480":"00f1a578","838":"dbd4a9e1"}[chunkId] + ".js";
};